/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Partner_Home_DiscountInputs */



/**
* | output |
* | --- |
* | "{percent} partner discount on seats and the Compliance Copilot" |
*
* @param {Partner_Home_DiscountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_discount = /** @type {((inputs: Partner_Home_DiscountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_DiscountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.percent} Partnerrabatt auf Plätze und den Compliance Copilot`)
	return /** @type {LocalizedString} */ (`${i?.percent} partner discount on seats and the Compliance Copilot`)
});